import { Core } from "@faire/design-tokens";
import styled from "styled-components";
/**
 * @trackcomponent
 * @supersededBy "@faire/web--source/slate/Tag/Tag#Tag"
 */ export var Tag = styled.div.withConfig({
    componentId: "sc-b7b24e18-0"
})([
    "text-align:center;padding:4px 16px;background-color:",
    ";margin-bottom:8px;margin-right:8px;white-space:nowrap;"
], Core.surface.subdued);
